import React, { useState, useEffect, useMemo } from "react";
import classes from "./addeditruleassignment.module.scss";
import {
  FormControlLabel,
  FormControl,
  TextField,
  Button,
  Grid,
  getNativeSelectUtilityClasses,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { useLocation } from "react-router-dom";
import NotificationView from "../../../../../Shared/Notification/NotificationView";

import { useNavigate, NavLink } from "react-router-dom";
import { constants } from "../../../../../Shared/Url/Constants";
import { CheckIsUserAdmin } from "../../../../../Shared/Utill/Utills";
import AdminControlsDataGrid from "../../../AdminControlsDataGrid";
import SnackBar from "../../../../../Shared/Snackbar/Snackbar";

import add from "../../../../../Resources/add.png";
import deleteimg from "../../../../../Resources/delete.png";
import add_disable from "../../../../../Resources/add_disable.png";
import delete_disable from "../../../../../Resources/delete_disable.png";
import DeleteRuleAssignmentDialog from "../Delete/DeleteRuleAssignmentDialog";
import DivisionDropDownComp from "../../../DivisionDropdown/DivisionDropdownComp";
import { AllControlSearchView } from "../Search/RuleAssignmentsSearch";
import { isEmpty } from "../../../../../Shared/Utill/Utills";
import {
  AddPlusIcon,
  DeleteIcon2,
} from "../../../../../Resources/availabilityicon/IconUtils";
import { IconStatus } from "../../../../../Resources/availabilityicon/AvailabilityIcons";

const AddEditRuleAssignment = () => {
  const personDetails = useSelector((state) => state.person.personData);
  const urlDetails = useSelector((state) => state.url.urlData);
  const colleagueTKN = Cookie.get("X_TKN");
  const token = Cookie.get("X_TKN");
  const location = useLocation();
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const [eventRAId, setEventRAId] = React.useState("");
  const [workSchedule, setWorkSchedule] = React.useState("");
  const [isDirty, setIsDirty] = React.useState({ work: false, group: false });
  console.log("data from search parent!" + JSON.stringify(location.state.id));
  const [flag, setFlag] = React.useState(location.state.flag);
  const history = useNavigate();
  const { message, severity, open } = isAlertOpen || {};
  const [readOnlyView, setReadyOnly] = React.useState(true);
  const [ongoingActionCompleted, setOngoingActionCompleted] =
    React.useState(true);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [divSelectedValue, setDivSelectedValue] = useState(null);
  const [searchLocation, setSearchLocation] = useState("");
  const [scheduleArea, setScheduleArea] = useState("");
  const [groupId, setGroupId] = useState("");
  const [ruleId, setRuleId] = useState("");
  const [divNbr, setDivNbr] = useState("");
  const [isFromSearch,setIsFromSearch] = useState(location.state.isSearch || false);

  useEffect(() => {
    if (flag === "A") {
      makeEditable();
    } else {
      // call api to get details
      getEventRuleAssignmentDetails();
    }
  }, []);

  const onDivDropDownSelect = (selectedDivision) => {
    setDivSelectedValue(selectedDivision);
  };

  const getEventRuleAssignmentDetails = (id = null) => {
    // : call get rule assignemnt details and assign state
    let earId = id === null ? location.state.id : id;
    let url = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVLL_RULE_ASSIGN_GET_BY_A_RULEID}/${earId}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        console.log(res);
        setSearchLocation(res.data.locNbr + "");
        setScheduleArea(res.data.dptNbr + "");
        setGroupId(res.data.groupId + "");
        setRuleId(res.data.ruleId + "");
        setDivNbr(res.data.divNbr);
        setEventRAId(res.data.araId);
      })
      .catch((err) => {
        setAlertOpen({
          open: true,
          severity: "error",
          message: err.response.data.message,
        });
      });
  };

  const cancelEditing = () => {
    // Add from on page cancel navigate to edit mode
    // Add from search page , cancel navigate to search page
    // Edit from search page , cancel navigate to search page
    // on page Add means flag == A & isFromSearch false
    // 
    if(flag === "A" && !isFromSearch){
      // on page add case
      setOngoingActionCompleted(true);
      // call api to reset values
      makeReadOnly();
      setFlag("E");
      setIsFromSearch(false);
      getEventRuleAssignmentDetails();//

      history("/controls/availabilityapplicationcontrols/ruleassignments/Edit",{ state: { flag: "E", isSearch: false, id: location.state.id}});
     // return;
    }else if(flag === "E" && !isFromSearch) {
      setOngoingActionCompleted(true);
      // call api to reset values
      getEventRuleAssignmentDetails();
      makeReadOnly();
    } else {
      history("/controls/availabilityapplicationcontrols/ruleassignments");
    }
  };

  const makeEditable = () => {
    setOngoingActionCompleted(false);
    console.log(readOnlyView + " ready only ");
    if (readOnlyView == true) {
      setReadyOnly(false);
    }
  };
  const makeReadOnly = () => {
    //on click of save
    setOngoingActionCompleted(true);
    if (readOnlyView == false) {
      setReadyOnly(true);
    }
  };

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const saveData = () => {
    //: validation for fields
    if (!ValidateAddEdit()) {
      return;
    }

    if (flag === "A") {
      // save data and call edit api
      addRuleAssignmentAPI();
    } else {
      // call edit rule assignment API
      editRuleAssignmentAPI();
    }
  };

  const onCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  const onDeleteCallback = (responseType, message) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message: message,
    });
    // refresh data
    if (responseType == "success") {
      // navigate back to event search page
       history('/controls/availabilityapplicationcontrols/ruleassignments', { state: {message: message,isDelete: true }});
    }
  };

  const addRuleAssignmentBtnClick = () => {
    setIsFromSearch(false);
    setFlag("A");
    makeEditable();
    setSearchLocation("");
    setScheduleArea("");
    setGroupId("");
    setRuleId("");
    setDivNbr(null);
    setDivSelectedValue(null);
    history("/controls/availabilityapplicationcontrols/ruleassignments/Add", {
      state: { flag: "A", isSearch: false, id: location.state.id },
    });
  };

  const onDeleteAction = () => {
    setOpenDeleteDialog(true);
  };

  const ValidateAddEdit = () => {
    let isDataValid = true;
    if (divSelectedValue == null) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please select Division",
      });
      return isDataValid;
    }
    if (isEmpty(searchLocation)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please type Location",
      });
      return isDataValid;
    }
    if (isEmpty(scheduleArea)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please type Schedule Area",
      });
      return isDataValid;
    }
    if (isEmpty(groupId)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please type Group ID",
      });
      return isDataValid;
    }
    if (isEmpty(ruleId)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please type Rule ID",
      });
      return isDataValid;
    }
    if (isNaN(searchLocation)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Location should be Numeric.",
      });
      return isDataValid;
    } else if (isNaN(scheduleArea)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Schedule Area should be Numeric.",
      });
      return isDataValid;
    } else if (isNaN(groupId)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Group ID should be Numeric.",
      });
      return isDataValid;
    } else if (isNaN(ruleId)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Rule ID should be Numeric.",
      });
    }
    return isDataValid;
  };

  const addRuleAssignmentAPI = () => {
    let data = {
      groupId: groupId,
      divNbr: divSelectedValue.divNbr,
      locNbr: searchLocation,
      dptNbr: scheduleArea,
      ruleId: ruleId,
      lastUpdatedBy: personDetails.emplID,
    };

    axios
      .post(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_RULE_ASSIGN_ADD}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        setAlertOpen({
          open: true,
          severity: "success",
          message: "Rule Assignment added successfully",
        });
        setSearchLocation(res.data.locNbr + "");
        setScheduleArea(res.data.dptNbr + "");
        setGroupId(res.data.groupId + "");
        setRuleId(res.data.ruleId + "");
        setDivNbr(res.data.divNbr);
        setEventRAId(res.data.araId);
        makeReadOnly();
        setFlag("E");
        getEventRuleAssignmentDetails(res.data.araId);
      })
      .catch((err) => {
        setAlertOpen({
          open: true,
          severity: "error",
          message: err.response.data.message,
        });
      });
  };

  const editRuleAssignmentAPI = () => {
    let data = {
      groupId: groupId,
      divNbr: divSelectedValue.divNbr,
      locNbr: searchLocation,
      dptNbr: scheduleArea,
      ruleId: ruleId,
      lastUpdatedBy: personDetails.emplID,
    };

    axios
      .put(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVLL_RULE_ASSIGN_UPDATE}/${eventRAId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        setAlertOpen({
          open: true,
          severity: "success",
          message: "Rule Assignments updated successfully",
        });
        makeReadOnly();
        getEventRuleAssignmentDetails(eventRAId);
      })
      .catch((err) => {
        setAlertOpen({
          open: true,
          severity: "error",
          message: err.response.data.message,
        });
      });
  };
  return (
    <div className={classes.pagemargin}>
      <AllControlSearchView />
      <div style={{ width: "100%" }}>
        <div
          className={classes.eventpagetitle}
          style={{ textAlign: "left", width: "40%" }}
        >
          {flag == "A" ? "Add" : "Record ID " + eventRAId}
        </div>
        <div className={classes.icon_text_wrap}>
          <div
            className={classes.icon_text}
            onClick={
              ongoingActionCompleted ? addRuleAssignmentBtnClick : undefined
            }
          >
            <AddPlusIcon
              type={
                ongoingActionCompleted ? IconStatus.NORMAL : IconStatus.DISABLED
              }
            />
            <div
              className={classes.icon_text}
              style={{
                color: ongoingActionCompleted ? "inherit" : "grey",
                display: "inline-block",
                marginLeft: "5px",
              }}
            >
              <u> Add </u>
            </div>
          </div>
          <div
            className={classes.icon_text}
            onClick={() =>
              !ongoingActionCompleted ||
              (searchLocation == 0 &&
              scheduleArea == 0)
                ? null
                : onDeleteAction()
            }
          >
            <DeleteIcon2
              type={
                !ongoingActionCompleted ||
                (searchLocation == 0 &&
                scheduleArea == 0)
                  ? IconStatus.DISABLED
                  : IconStatus.NORMAL
              }
            />
            <div
              className={classes.icon_text}
              style={{
                color:
                  !ongoingActionCompleted ||
                  (searchLocation == 0 &&
                  scheduleArea == 0)
                    ? "grey"
                    : "inherit",
                 marginLeft: "5px",
              }}
            >
              <u>Delete</u>
            </div>
          </div>
        </div>
      </div>
      {readOnlyView && (
        <NotificationView
          message={"'Read-only' view, click on 'Edit' to edit event details."}
          severity="info"
        />
      )}
      <div className={classes.eventiconmargin}>
        <div className={classes.pagesubtitle}> </div>
        {/*  Event details code goes here */}

        <div>
          <div className={classes.eventpagemargin}>
            <Grid container spacing={4} rowSpacing={6}>
              <Grid key={0} item xs={2}>
                <DivisionDropDownComp
                  onDivChange={(e) => onDivDropDownSelect(e)}
                  preSelectDivNbr={divNbr}
                  readOnly={readOnlyView}
                />
              </Grid>
              <Grid key={1} item xs={2}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Location"
                    onChange={(e) => setSearchLocation(e.target.value)}
                    value={searchLocation}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Schedule Area"
                    onChange={(e) => setScheduleArea(e.target.value)}
                    value={scheduleArea}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Group ID"
                    onChange={(e) => setGroupId(e.target.value)}
                    value={groupId}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Rule ID"
                    onChange={(e) => setRuleId(e.target.value)}
                    value={ruleId}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>

              <Grid key={2} item xs={4}></Grid>
              <Grid key={3} item xs={2}></Grid>
              <Grid key={4} item xs={2}>
                {!readOnlyView && (
                  <Button
                    onClick={cancelEditing}
                    color="secondary"
                    size="large"
                    style={{
                      minWidth: "100%",
                      minHeight: "120%",
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </Grid>
              <Grid key={5} item xs={2}>
                {readOnlyView && (
                  <Button
                    sx={{ minWidth: "100%" }}
                    color="primary"
                    size="large"
                    onClick={makeEditable}
                  >
                    Edit
                  </Button>
                ) }
                {!readOnlyView && (
                  <Button
                    color="primary"
                    size="large"
                    style={{
                      minWidth: "100%",
                      minHeight: "120%",
                    }}
                    onClick={saveData}
                  >
                    Save
                  </Button>
                )}
              </Grid>
            </Grid>
          </div>
        </div>

        <SnackBar
          open={open}
          message={message}
          severity={severity}
          onClose={handleAlertNotifClose}
        ></SnackBar>
        {openDeleteDialog && (
          <DeleteRuleAssignmentDialog
            onCloseDialog={onCloseDialog}
            onDeleteCallback={onDeleteCallback}
            data={eventRAId}
          />
        )}
      </div>
    </div>
  );
};
export default AddEditRuleAssignment;
